<template>
    <!-- 食事提供設定画面 -->
    <v-dialog v-model="dialog" persistent max-width="600px">
        <v-container>
            <v-card>
                <v-card-title class="InsertTitle">
                    <v-toolbar class="headline" color="primary" dark>食事提供マスタ</v-toolbar>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="2">
                            <div class="label">
                                平日
                            </div>
                            <div class="label">
                                土曜
                            </div>
                            <div class="label">
                                日曜
                            </div>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-switch label="提供あり" v-model="weekday_offer_flg" color="success" :disabled="commitCtrl">
                            </v-switch>
                            <v-switch label="提供あり" v-model="saturday_offer_flg" color="success" :disabled="commitCtrl">
                            </v-switch>
                            <v-switch label="提供あり" v-model="sunday_offer_flg" color="success" :disabled="commitCtrl">
                            </v-switch>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-switch label="締め日含む" v-model="weekday_reserv_flg" color="success" :disabled="commitCtrl">
                            </v-switch>
                            <v-switch label="締め日含む" v-model="saturday_reserv_flg" color="success"
                                :disabled="commitCtrl">
                            </v-switch>
                            <v-switch label="締め日含む" v-model="sunday_reserv_flg" color="success" :disabled="commitCtrl">
                            </v-switch>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <ryou-black-btn :label="'閉じる'" :handlerClick="handleCancel" :iconCls="'mdi-close'"
                        :disabled="commitCtrl"></ryou-black-btn>
                    <v-spacer></v-spacer>
                    <ryou-black-btn :label="'確定'" :handlerClick="handleOk" :disabled="commitCtrl"></ryou-black-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-container>
    </v-dialog>
</template>

<script>
    import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";

    export default {
        name: "MasterMealProvideDialog",
        components: {
            RyouBlackBtn
        },
        mounted() {
        },
        props: {
            url: {
                type: Object,
                required: true,
                default: () => { }
            }
        },
        data: () => ({
            commitCtrl: false,
            dialog: false,
            buildGroupId: "",
            dataExistFlag: 3,//データなし、新規
            weekday_offer_flg: false,//平日、提供有無
            weekday_reserv_flg: false,//平日、締め切りフラグ
            saturday_offer_flg: false,//土曜、提供有無
            saturday_reserv_flg: false,//土曜、締め切りフラグ
            sunday_offer_flg: false,//日曜、提供有無
            sunday_reserv_flg: false,//日曜、締め切りフラグ
        }),
        methods: {
            add(value) {
                this.buildGroupId = value;
                this.initData();
                this.open();
                this.title = "食事提供マスタ更新";
            },
            initData() {
                let formData = {
                    buildGroupId: this.buildGroupId
                }
                this.getRequest("/masterMeal/mealOfferGet", formData, this.$store.getters.getUserToken).then(data => {
                    if (data.success) {
                        // 戻りの結果は空ではありません。
                        if (data.result.length != 0) {
                            for (let a = 0; a < data.result.length; a++) {
                                if (a == 0) {
                                    this.weekday_offer_flg = Number(data.result[a].offer_flg);
                                    this.weekday_reserv_flg = Number(data.result[a].reserv_flg);
                                }
                                else if (a == 1) {
                                    this.saturday_offer_flg = Number(data.result[a].offer_flg);
                                    this.saturday_reserv_flg = Number(data.result[a].reserv_flg);
                                }
                                else {
                                    this.sunday_offer_flg = Number(data.result[a].offer_flg);
                                    this.sunday_reserv_flg = Number(data.result[a].reserv_flg);
                                }
                            }
                            this.dataExistFlag = 1;//データあり、編集
                        } else {
                            this.weekday_offer_flg = false;//平日、提供有無
                            this.weekday_reserv_flg = false;//平日、締め切りフラグ
                            this.saturday_offer_flg = false;//土曜、提供有無
                            this.saturday_reserv_flg = false;//土曜、締め切りフラグ
                            this.sunday_offer_flg = false;//日曜、提供有無
                            this.sunday_reserv_flg = false;//日曜、締め切りフラグ

                            this.dataExistFlag = 3;//データあり、編集dataExistFlag
                        }
                    }
                });
            },
            handleOk() {
                let formData = {
                    user_id: this.$store.getters.getUserId,
                    build_group_id: Number(this.buildGroupId),
                    weekday_offer_flg: Number(this.weekday_offer_flg),
                    weekday_reserv_flg: Number(this.weekday_reserv_flg),
                    saturday_offer_flg: Number(this.saturday_offer_flg),
                    saturday_reserv_flg: Number(this.saturday_reserv_flg),
                    sunday_offer_flg: Number(this.sunday_offer_flg),
                    sunday_reserv_flg: Number(this.sunday_reserv_flg),
                    dataExistFlag: Number(this.dataExistFlag)
                }

                this.commitCtrl = true;
                this.putRequest("/masterMeal/mealOfferUpdate", formData, this.$store.getters.getUserToken).then(() => {
                    this.commitCtrl = false;
                });
            },
            handleCancel() {
                this.close();
            },
            close() {
                this.dialog = false;
            },
            open() {
                this.dialog = true;
                if (this.$refs.p1DialogForm) {
                    this.$refs.p1DialogForm.reset();
                    this.$refs.p1DialogForm.resetValidation();
                }
            }
        }
    };
</script>

<style scoped>
    .InsertTitle {
        padding: 0px 0px 12px !important;
    }

    .label {
        height: 65px;
        padding: 25px 0px 25px;
    }
</style>